export default "__VITE_ASSET__5ixqUBxL__"